// @flow

export const BRAND_PURPLE = '#771B97';
export const BRAND_PURPLE_HOVER = '#5E1478';
export const ERROR_ICON_BACKGROUND = '#FDECEF';
export const INFO_BOX_BACKGROUND = '#E5EEFF';
export const ACCENT_PURPLE = '#6B28D8';
export const COUNTDOWN_BACKGROUND = '#F4E8FF';
export const STEP_CARD_BACKGROUND = '#F9FAFC';
